import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },

  backButton: {
    marginRight: theme.spacing(1),
  },

  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },

  spinner: {
    marginTop: 10,
  },

  formControl: {
    paddingTop: theme.spacing(2),
  },

  select: {
    height: 40,
  },

  phoneNumberWrapper: {
    '& .flag-dropdown': {
      borderRadius: '10px 0 0 10px !important',
    },
  },

  snackbarActionLink: {
    fontWeight: 600,
    marginLeft: 20,
    cursor: 'pointer',
  },
}));
